import { useGridContext } from '../../../../../../../_grid/contexts/gridContext';
import { useHeatmapBackground } from '../../../../hooks/useHeatmapBackground';
import { useUISettings } from '../../../../../../../../../context/network/http/QueryProvider/queries/UISettings';
import { GridCell, GridTotalColumnRow } from '../../../../../../../../../api/generated/data-contracts';
import { useFixedCellValue } from '../../../../../../../_grid/hooks/useFixedCellValue';
import { memo } from 'react';

export const ColoredTotalCell = memo(function ColoredTotalCell({
    cell,
    isRowExpanded,
	totalColumnRow
}: {
    cell: GridCell;
    isRowExpanded: boolean;
	totalColumnRow: GridTotalColumnRow;
}) {
	const { totalCapacity = 1 } = totalColumnRow?.metadata ?? {};
    const {
        data: {
            settings: {
                resourcePlannerSettings: {
                    gridSettings: {
                        //
                        heatMapTextColor,
                        heatMapClassicColors,
                        heatMapColorOffset,
                        heatMapColorSaturation,
                        heatMapInvertSpectrum,
                        heatMapLightness,
                        heatMapOverAllocation,
                        heatMapUnderAllocation,
                        equalAllocationColor,
                        overAllocationColor,
                        underAllocationColor,
                    },
                },
            },
        },
    } = useUISettings();

    const { useGridCellValue } = useGridContext();
    const stateValue = useGridCellValue(cell);
    const backgroundColor = useHeatmapBackground({
        value: stateValue.toNumber(),
        totalCapacity,
        maxOverAllocationPercent: heatMapOverAllocation,
        maxUnderAllocationPercent: heatMapUnderAllocation,
        colorSaturation: heatMapColorSaturation,
        lightness: heatMapLightness,
        colorOffset: heatMapColorOffset,
        invertSpectrum: heatMapInvertSpectrum,
        classicColors: heatMapClassicColors,
        equalAllocationColor,
        overAllocationColor,
        underAllocationColor,
    });
    const value = useFixedCellValue(stateValue);

    return (
        <div
            style={{
                //
                backgroundColor,
                height: '100%',
                width: '100%',
                ...(isRowExpanded && {
                    width: 80,
                    height: 32,
                }),
                transition: '.3s ease',
                position: 'relative',
                cursor: 'pointer',
            }}
        >
            <span
                style={{
                    position: 'absolute',
                    top: '50%',
                    ...(isRowExpanded
                        ? {
                              transform: 'translate(-100%, -50%)',
                              left: 'calc(100% - 8px)',
                          }
                        : {
                              transform: 'translate(-50%, -50%)',
                              left: '50%',
                          }),
                    transition: '.3s',
                    color: heatMapTextColor,
                    gap: 5,
                    display: 'flex',
                }}
            >
                {/* {isAdminProject && (
                    <TooltipHost
                        styles={{
                            root: {
                                //
                                flexGrow: 1,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'left',
                                cursor: 'help',
                            },
                        }}
                        content={<>Administrative Project: KPI inapplicable as no requests are permitted. Consider creating a view without admin projects</>}
                    >
                        <Icon iconName="Info" styles={{ root: { fontSize: 18, display: 'block' } }} />
                    </TooltipHost>
                )} */}
                {value}
            </span>
        </div>
    );
});
